import { Controller, useFormContext } from 'react-hook-form'

import { Form, FormItemProps, Select, SelectProps } from 'antd'

import { RULE_MESSAGE } from '@/shared/constants/message-text'
import { IOptions } from '@/shared/types/data'

import styles from './styles.module.scss'

interface IProps {
  name: string
  options: IOptions[]
  label?: string
  onChange?: (value: number | string) => void
  required?: boolean
  formItemProps?: FormItemProps
  selectProps?: SelectProps
}

export const SelectFormItem = ({
  name,
  label,
  options,
  onChange,
  required = false,
  formItemProps,
  selectProps,
}: IProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Form.Item
      className={styles.item}
      {...formItemProps}
      label={label}
      name={name}
      required={required}
      validateStatus={errors[name] && 'error'}
      help={
        errors[name] &&
        ((errors[name]?.message ??
          RULE_MESSAGE[errors[name]?.type as string]) as string)
      }
    >
      <Controller
        control={control}
        name={name}
        rules={{ required }}
        render={({ field }) => (
          <Select
            {...field}
            {...selectProps}
            options={options}
            onChange={value => {
              field.onChange(value)
              onChange && onChange(value)
            }}
          />
        )}
      />
    </Form.Item>
  )
}
